import { render, staticRenderFns } from "./sample-text-image-modal-with-secondary.vue?vue&type=template&id=6d2d2e5c&"
import script from "./sample-text-image-modal-with-secondary.vue?vue&type=script&lang=js&"
export * from "./sample-text-image-modal-with-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports